// @flow

import Loadable from "react-loadable";
import DynamicImportLoader from "app/components/atoms/DynamicImportLoader/DynamicImportLoader";
import type { InteractivesMenuItemConfig } from "../interactives-list";
import DisplayImage from "./image.png";

const description =
  "A configurable multimedia timeline widget for creating a chronological timeline of events using images, quotes and audio.";
const CONFIG: InteractivesMenuItemConfig = {
  name: "Multimedia Timeline",
  id: "multimedia-timeline",
  groupsWithAccess: ["specialist_user", "editor_user"],
  linkPrefix: "/interactives",
  tags: ["Configurable", "Explainer"],
  description,
  image: DisplayImage,
  cradleIframeUrlRoot:
    "https://www.smh.com.au/interactive/modules/multimedia-timeline/index.html?resizable=true",
  ConfigComponent: Loadable({
    delay: 200, // See 'Avoiding Flash Of Loading Component': https://github.com/jamiebuilds/react-loadable
    loader: () =>
      import(// Set webpackChunkName to dynamic import PhotoGalleryConfigTool in order to get all the css styles for the image crop.
      /* webpackChunkName: "PhotoGalleryConfigTool" */ "app/components/tools/MultimediaTimeline/MultimediaTimeline"),
    loading: DynamicImportLoader,
    modules: ["MultimediaTimeline"]
  })
};

export default CONFIG;
